/* tslint:disable */

declare var Object: any;
export interface TtamoddestinationInterface {
  "code": string;
  "nameEn": string;
  "nameId": string;
  "nameMy": string;
  "nameTh": string;
  "orderNo"?: number;
  "createdDate": Date;
  "createdBy": string;
  "modifiedDate": Date;
  "modifiedBy": string;
}

export class Ttamoddestination implements TtamoddestinationInterface {
  "code": string;
  "nameEn": string;
  "nameId": string;
  "nameMy": string;
  "nameTh": string;
  "orderNo": number;
  "createdDate": Date;
  "createdBy": string;
  "modifiedDate": Date;
  "modifiedBy": string;
  constructor(data?: TtamoddestinationInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Ttamoddestination`.
   */
  public static getModelName() {
    return "Ttamoddestination";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Ttamoddestination for dynamic purposes.
  **/
  public static factory(data: TtamoddestinationInterface): Ttamoddestination{
    return new Ttamoddestination(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Ttamoddestination',
      plural: 'Ttamoddestinations',
      path: 'Ttamoddestinations',
      properties: {
        "code": {
          name: 'code',
          type: 'string'
        },
        "nameEn": {
          name: 'nameEn',
          type: 'string'
        },
        "nameId": {
          name: 'nameId',
          type: 'string'
        },
        "nameMy": {
          name: 'nameMy',
          type: 'string'
        },
        "nameTh": {
          name: 'nameTh',
          type: 'string'
        },
        "orderNo": {
          name: 'orderNo',
          type: 'number'
        },
        "createdDate": {
          name: 'createdDate',
          type: 'Date'
        },
        "createdBy": {
          name: 'createdBy',
          type: 'string'
        },
        "modifiedDate": {
          name: 'modifiedDate',
          type: 'Date'
        },
        "modifiedBy": {
          name: 'modifiedBy',
          type: 'string'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/Ttamoddestination.ts